import React from "react";

import { css, keyframes } from "@emotion/css";
import SubLogo from "../../../img/svg/home/hero-title-icon.svg";
import BGImg from "../../../img/jpg/home/hero-bg.jpg";
import BGMImg from "../../../img/jpg/home/hero-bg-m.jpg";
import SliderBG from "../../../img/png/home/frame.png";
import Slider2BG from "../../../img/png/home/frame-2.png";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useIsMobile } from "../../../components/helpers/ScreenCheck";
import { Link } from "react-router-dom";
import buttons from "../../../styles/buttons";
import { useI18n } from "../../../i18n";

const Hero = () => {
  const isMobile = useIsMobile(744);
  const { t } = useI18n();
  return (
    <div style={{ backgroundColor: "#000000", overflow: "hidden" }}>
      <div className={style.bg}>
        <img src={isMobile ? BGMImg : BGImg} alt="" />
      </div>
      <div className={style.container}>
        <div className="wrapper">
          <h1 className="boost">{t("home_hero_boost")}</h1>
          <h1 className="your">{t("home_hero_your")}</h1>
          <h1 className="aura">
            <span className="heading-text">
              <img src={SubLogo} alt={t("home_hero_logo_alt")} className="logo" />
              {t("home_hero_fit")}
            </span>
            <p className="desktop">{t("home_hero_desc")}</p>
              <>
                <Link
                  className={`${buttons.secondary} ${buttons.green} desktop`}
                  to={"/subscribe"}
                >
                  {t("home_join_waitlist")}
                </Link>
                <Link
                  className={`${buttons.secondary} ${buttons.green} full`}
                  style={{ marginRight: "200px" }}
                  to={"/subscribe"}
                >
                  {t("home_join_waitlist")}
                </Link>
              </>
            {/* <Clickable className="desktop" style={{ marginLeft: 7, marginRight: 7 }}>
            <img src={IOS} alt="" className="store-image" />
          </Clickable>
          <Clickable className="desktop" style={{ marginLeft: 7, marginRight: 7 }}>
            <img src={GGPS} alt="" className="store-image" />
          </Clickable> */}
            <p className="full">{t("home_hero_desc")}</p>
          </h1>
        </div>
      </div>
      <div className={style.slider}>
        <div className="slider left">
          <ul>
            <li>
              <span className="text">{t("home_hero_ticker")}</span>
            </li>
          </ul>
          <ul aria-hidden="true">
            <li>
              <span className="text">{t("home_hero_ticker")}</span>
            </li>
          </ul>
        </div>
        <div className="slider right">
          <ul>
            <li>
              <span className="text">{t("home_hero_ticker")}</span>
            </li>
          </ul>
          <ul aria-hidden="true">
            <li>
              <span className="text">{t("home_hero_ticker")}</span>
            </li>
          </ul>
        </div>
      </div>
      <span className={style.info}>
        <p>{t("home_hero_desc")}</p>
        <div>
            <Link
              className={`${buttons.secondary} ${buttons.green}`}
              to={"/subscribe"}
            >
              {t("home_join_waitlist")}
            </Link>
          {/* <Clickable>
            <img src={IOS} alt="" className="store-image" />
          </Clickable>
          <Clickable>
            <img src={GGPS} alt="" className="store-image" />
          </Clickable> */}
        </div>
      </span>
    </div>
  );
};

const animation = keyframes({
  to: { transform: "translateX(-100%)" },
});

const animationRight = keyframes({
  from: { transform: "translateX(-100%)" },
});

const style = {
  info: css({
    display: "none",
    marginTop: -200,
    marginBottom: 100,

    p: {
      color: "#FFF",
      textAlign: "center",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
      width: 400,
    },

    img: {
      width: 170.54,
    },

    div: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      alignContent: "center",
      gap: 10,
    },

    [laptop]: {
      marginTop: -260,
      marginBottom: 20,
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 50,
    },
    [tablet]: {
      marginTop: -345,
      p: {
        width: 280,
      },
    },
  }),
  slider: css({
    marginTop: 30,
    overflowX: "clip",
    height: 500,
    position: "relative",

    ".slider": {
      overflow: "hidden",
      userSelect: "none",
      display: "flex",
      gap: 0,
      transform: "rotate(-6deg)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      backgroundSize: "cover",
      backgroundImage: `url(${Slider2BG})`,
      position: "absolute",
      marginLeft: -50,
      marginRight: -50,

      "&.right": {
        backgroundImage: `url(${SliderBG})`,
        transform: "rotate(12deg)",
        top: 80,

        ul: {
          animation: `${animationRight} 30s linear infinite`,
        },
      },

      ul: {
        listStyle: "none",
        flexShrink: 0,
        minWidth: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 0,
        animation: `${animation} 30s linear infinite`,
      },

      ".text": {
        color: "#0F0F0F",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 65,
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "normal",
        letterSpacing: 3.9,
      },
    },

    [desktop]: {
      marginTop: 60,
      ".slider": {
        ".text": {
          fontSize: 45,
        },
      },
    },
    [laptop]: {
      marginTop: 70,
      ".slider": {
        "&.right": {
          top: 40,
        },
        ".text": {
          fontSize: 36,
        },
      },
    },
    [tablet]: {
      marginTop: 20,
      ".slider": {
        "&.right": {
          top: 10,
        },
        ".text": {
          fontSize: 27,
        },
      },
    },
  }),
  bg: css({
    width: "100%",
    height: 1206,
    position: "absolute",
    left: 0,
    top: 0,
    zIndex: 0,
    overflow: "hidden",

    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      overflow: "unset",
    },

    [desktop]: {
      height: 945,
    },
    [laptop]: {
      height: 798,
    },
    [tablet]: {
      height: 680,
      right: 200,
    },
  }),
  container: css({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: 1830,
    margin: "auto",
    backgroundColor: "#f5f5f5",
    marginTop: 610,

    h1: {
      color: "#FFF",
      fontFamily: "Yapari Trial Extra Bold",
      fontSize: 92,
      fontStyle: "normal",
      fontWeight: 800,
      lineHeight: 1.2,

      "&.boost": {},
      "&.your": {
        marginLeft: 105,
      },
      "&.aura": {
        marginLeft: 150,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        ".heading-text": {
          marginRight: 30,
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "flex-start",
        },
        ".store-image": {
          backdropFilter: "blur(6px)",
          borderRadius: 20,
          width: 220,
        },

        ".clickable": {
          display: "flex",
        },
      },
    },

    p: {
      color: "#FFF",
      fontFamily: "Inter",
      fontSize: 26.62,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
      maxWidth: 365,
      marginLeft: 20,
      marginRight: 20,
    },

    ".wrapper": {
      maxWidth: 1261,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignContent: "flex-start",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      backgroundRepeat: "no-repeat",
      padding: 40,
      zIndex: 1,
      marginRight: 100,
    },

    ".content": {
      display: "flex",
      flexDirection: "column",
      alignContent: "flex-start",
      flexWrap: "nowrap",
      justifyContent: "space-around",
      alignItems: "flex-start",
      paddingLeft: 120,
    },

    ".logo": {
      height: "95px",
      width: "95px",
      marginTop: -20,
      marginRight: 50,
    },

    ".full": {
      display: "flex",
    },
    ".desktop, .mobile, .laptop, .tablet": {
      display: "none",
    },
    [desktop]: {
      marginTop: 410,
      ".full": {
        display: "none !important",
      },
      ".desktop": {
        display: "flex",
      },
      h1: {
        fontSize: 78,
        "&.your": {
          marginLeft: 75,
        },
        "&.aura": {
          marginLeft: 95,
          width: "100%",
          justifyContent: "flex-start",

          ".heading-text": {
            width: "100%",
          },

          ".store-image": {
            width: 200,
          },
        },
      },

      p: {
        marginLeft: 0,
        marginRight: 20,
      },
      ".wrapper": {
        padding: 30,
        marginRight: 0,
        marginLeft: 30,
        width: "100%",
      },

      ".logo": {
        height: "75px",
        width: "75px",
        marginTop: -15,
        marginRight: 30,
      },
    },
    [laptop]: {
      marginTop: 410,
      ".wrapper": {
        width: "auto",
      },
      ".desktop": {
        display: "none !important",
      },
      ".laptop": {
        display: "flex",
      },
      h1: {
        fontSize: 58,
        letterSpacing: "1px",

        "&.your": {
          marginLeft: 65,
        },
        "&.aura": {
          marginLeft: 90,
        },
      },

      p: {
        marginLeft: 0,
        marginRight: 0,
        alignSelf: "stretch",
      },
      ".logo": {
        height: "60px",
        width: "60px",
        marginTop: -10,
        marginRight: 20,
      },
    },
    [tablet]: {
      marginTop: 410,
      h1: {
        fontSize: 30,
        textAlign: "center",
        letterSpacing: 0,
        "&.boost": {
          marginLeft: 0,
        },
        "&.your": {
          marginLeft: 0,
        },
        "&.aura": {
          marginLeft: 0,
          ".heading-text": {
            marginRight: 0,
          },
        },
      },
      ".wrapper": {
        paddingLeft: 15,
        paddingRight: 15,
      },

      ".content": {
        paddingLeft: 0,
      },
      ".logo": {
        height: "40px",
        width: "40px",
        marginTop: -5,
        marginRight: 10,
      },
    },
  }),
};

export default Hero;
